import { render } from "./InputFieldLabel.vue?vue&type=template&id=62190085&scoped=true"
import script from "./InputFieldLabel.vue?vue&type=script&lang=js"
export * from "./InputFieldLabel.vue?vue&type=script&lang=js"

import "./InputFieldLabel.vue?vue&type=style&index=0&id=62190085&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62190085"]])

export default __exports__